import { defineStore, storeToRefs } from "pinia";

import { ref, computed } from "vue";

import { useUserStore } from "./user";

import LicenseService from "@/services/license";
import CombosService from "@/services/combos";



export const useLicenseStore = defineStore("license", () => {
  const us = useUserStore();
  const { token } = storeToRefs(us);

  const ls = new LicenseService();

  const cs = new CombosService();




  const licenses = ref([]);
  const expiredLicenses = ref([]);
  const expiredLicensesTotalRecords = ref(0);
  const aboutToExpireLicenses = ref([]);
  const aboutToExpireLicensesTotalRecords = ref(0);
  const inactiveLicenses = ref([]);
  const pendingLicenses = ref([]);
  const pendingLicensesTotalRecords = ref(0);
  const localLicenses = ref([]);
  const totalRecords = ref(0);
  const localLicensesTotalRecords = ref(0);

  const campainList = ref([]);
  const selectedCampain = ref(null);
  const softwareList = ref([]);
  const hardwareList = ref([]);
  const countryList = ref([]);

  const list_page = ref(0);
  const companyName = ref("");
  const nif = ref("");
  const clientNumber = ref("");
  const software = ref(-1);
  const serialNumber = ref("");
  const state = ref(1);
  const visible_state = ref(-1);

  const orderStatusList = ref([]);
  const orderStatusTotalRecords = ref(0);

  const transactionsList = ref([]);

  // Hardware Request Status State
  const hardwareRequestStatusList = ref([]);
  const hardwareRequestStatusTotalRecords = ref(0);

  function resetFilters() {
    list_page.value = 0;
    companyName.value = "";
    nif.value = "";
    clientNumber.value = "";
    software.value = -1;
    serialNumber.value = "";
    state.value = 1;
  }

  async function filterLicenses(
    empresa,
    contribuinte,
    cliente,
    software,
    serial,
    state,
    page,
    take,
    infinite = false
  ) {
    try {
      const data = await ls.filterLicenceList(
        token.value,
        empresa,
        contribuinte,
        cliente,
        software,
        serial,
        state,
        page,
        take
      );
      const list = data?.data ?? [];
      licenses.value = infinite ? [...licenses.value, ...list] : list;
      totalRecords.value = data.meta.itemCount;
      return list;
    } catch (error) {
      licenses.value = infinite ? licenses.value : [];
    }
  }



  async function getLicenses2(search, page, take, infinite = false) {
    try {
      const data = await ls.getLicenseList(token.value, search, page, take);
      const list = data?.data ?? [];
      licenses.value = infinite ? [...licenses.value, ...list] : list;
      totalRecords.value = data.meta.total_items;
      return list;
    } catch (error) {
      licenses.value = infinite ? licenses.value : [];
    }
  }

  async function getCampainList() {
    try {
      const data = await cs.getCampainList(token.value);

      campainList.value =
        data.campanhas?.map((e) => {
          if (!e.id) {
            return { ...e, id: -1 };
          }
          return { ...e, descricao: `${e.descricao} - ${e.id}` };
        }) || [];

      softwareList.value =
        data.softwares?.map((e) => {
          return { ...e, descricao: `${e.descricao} - ${e.codigo}` };
        }) || [];

      return data;
    } catch (error) {
      campainList.value = [];
    }
  }

  async function getCampainDetail(
    campainId,
    software = 0,
    version = 0,
    countryId = "PT"
  ) {
    try {
      const data = await cs.getCampainDetail(
        token.value,
        campainId,
        software,
        version,
        countryId
      );
      selectedCampain.value = data;
      hardwareList.value =
        (data?.hardware ? [data.hardware] : []).map((e) => {
          return {
            ...e,
            descricao: `${e.descricao} - ${e.codigo}`,
            hardware: e.codigo,
          };
        }) || [];

      return data;
    } catch (error) {
      selectedCampain.value = null;
      return null;
    }
  }

  async function getSoftwareList() {
    try {
      const data = await cs.getSofwareList(token.value);
      softwareList.value = data.map((e) => {
        return { ...e, descricao: `${e.descricao} - ${e.codigo}` };
      });
      return data;
    } catch (error) {
      softwareList.value = [];
    }
  }

  async function getHardwareList(softwareId, countryId = "PT") {
    try {
      const data = await cs.getHardwareList(token.value, softwareId, countryId);
      hardwareList.value = data.map((e) => {
        return { ...e, descicao: `${e.descricao} - ${e.hardware}` };
      });
      return data;
    } catch (error) {
      hardwareList.value = [];
    }
  }

  async function orderLicense(license) {
    try {
      const data = await ls.orderLicense(token.value, license);
      return {
        success: true,
        message: "new_license.order_success",
        data: data,
      };
    } catch (error) {
      return {
        success: false,
        message: "new_license.order_error",
        data: error,
      };
    }
  }

  async function orderLicenseV2(license) {
    try {
      const data = await ls.orderLicenseV2(token.value, license);
      return {
        success: true,
        message: "new_license.order_success",
        data: data,
      };
    } catch (error) {
      return {
        success: false,
        message: "new_license.order_error",
        data: error,
      };
    }
  }

  async function getSerialEmail(serial) {
    try {
      const data = await ls.getSerialEmail(token.value, serial);
      return {
        success: true,
        data: data,
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || "store.detail.edit_email_error",
        data: error,
      };
    }
  }

  async function updateSerialEmail(serial, email) {
    try {
      const data = await ls.updateSerialEmail(token.value, serial, email);
      return {
        success: true,
        message: "store.detail.edit_email_success",
        data: data,
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || "store.detail.edit_email_error",
        data: error,
      };
    }
  }

  async function getExpiringLicenceList() {
    try {
      const data = await ls.getExpiringLicenceList(token.value);
      expiredLicenses.value = data.data.filter((e) => e.software != 13); // not include ZSGO
      return data;
    } catch (error) {
      console.log("getExpiringLicenceList", error);
      expiredLicenses.value = [];
    }
  }

  async function getInactiveLicenceList() {
    try {
      const data = await ls.getInactiveLicenceList(token.value);
      inactiveLicenses.value = data.data;
      return data;
    } catch (error) {
      console.log("getInactiveLicenceList", error);
      inactiveLicenses.value = [];
    }
  }

  async function getPendingLicenceList() {
    try {
      const data = await ls.getPendingLicenceList(token.value);
      pendingLicenses.value = data.data;
      return data;
    } catch (error) {
      console.log("getPendingLicenceList", error);
      pendingLicenses.value = [];
    }
  }

  //disableLicense function
  async function disableLicense(licenseId) {
    try {
      const data = await ls.disableLicense(token.value, licenseId);
      return {
        success: true,
        message: "license_disable.success",
        data: data,
      };
    } catch (error) {
      return {
        success: false,
        message: "license_disable.error",
        data: error,
      };
    }
  }

  //enableLicense function
  async function enableLicense(licenseId) {
    try {
      const data = await ls.enableLicense(token.value, licenseId);
      return {
        success: true,
        message: "license_enable.success",
        data: data,
      };
    } catch (error) {
      return {
        success: false,
        message: "license_enable.error",
        data: error,
      };
    }
  }

  async function getLicenseFile(licenceData, renew = false) {
    try {
      const data = await ls.getLicenseFile(token.value, licenceData, renew);
      return {
        success: true,
        message: "license_file.success",
        data: data,
      };
    } catch (error) {
      return {
        success: false,
        message: "license_file.error",
        data: error,
      };
    }
  }

  async function exportLicenceList(licdata) {
    try {
      const data = await ls.getExportFile(token.value, licdata);
      return {
        success: true,
        message: "license_file.success",
        data: data,
      };
    } catch (error) {
      return {
        success: false,
        message: "license_file.error",
        data: error,
      };
    }
  }

  async function exportLocalLicenceList(filters, format = 'csv') {
    try {
      const data = await ls.getLocalLicensesExportFile(token.value, filters, format);
      return {
        success: true,
        message: "license_file.success",
        data: data,
      };
    } catch (error) {
      return {
        success: false,
        message: "license_file.error",
        data: error,
      };
    }
  }

  async function renewLicense(renew_data) {
    try {
      const data = await ls.renewLicense(token.value, renew_data);
      return {
        success: true,
        message: "license_renew.success",
        data: data,
      };
    } catch (error) {
      return {
        success: false,
        message: "license_renew.error",
        data: error,
      };
    }
  }

  async function renewZSFACTLicense(renew_data) {
    try {
      const data = await ls.renewZSFACTLicense(token.value, renew_data);
      return {
        success: true,
        message: "license_renew.success",
        data: data,
      };
    } catch (error) {
      return {
        success: false,
        message: "license_renew.error",
        data: error,
      };
    }
  }

  async function checkNif(nif, country) {
    try {

      const data = await ls.checkNif(token.value, nif,country);
      // alert(JSON.stringify(data))
      return {
        success: true,
        message: "check_nif.order_success",
        data: data,
      };
    } catch (error) {
      return {
        success: false,
        message: error?.response?.data?.message || "check_nif.order_error",
        data: error,
      };
    }
  }

  async function validateEmail(email) {
    try {
      const data = await ls.validateEmail(token.value, email);
      return {
        success: true,
        data: data,
      };
    } catch (error) {
      return {
        success: false,
        data: error,
      };
    }
  }

  async function checkPartnerDemoLicense(contribuinte) {
    try {
      const data = await ls.checkPartnerDemoLicense(token.value, contribuinte);
      return {
        success: true,
        data: data?.data,
      };
    } catch (error) {
      return {
        success: false,
        data: null,
      };
    }
  }

  async function checkForExistingLicense(software_id, nif) {
    if (!nif || !software_id) return false;
    try {
      const data = await ls.checkForExistingLicense(
        token.value,
        software_id,
        nif
      );
      return {
        success: true,
        message: "check_software",
        data: data,
      };
    } catch (error) {
      return {
        success: false,
        message: error?.response?.data?.message || "check_software_error",
        data: error,
      };
    }
  }

  async function getZSGOLicenseData(serial) {
    try {
      const data = await ls.getZSGOLicenceData(token.value, serial);
      return data.data;
    } catch (error) {
      console.log("getZSGOLicenseData -> error", error);
    }
  }

  async function orderZSGOLicenseChange(data) {
    try {
      const response = await ls.orderZSGOLicenseChange(token.value, data);
      return {
        success: true,
        message: "orderZSGOLicenseChange_success",
        data: response,
      };
    } catch (error) {
      return {
        success: false,
        message: error?.response?.data?.message || "orderZSGOLicenseChange_error",
        data: error,
      };
    }
  }

  async function getLicenseOrderStatus(page = 1, per_page = 10, filters) {
    try {
      const data = await ls.getLicenseOrderStatus(token.value, filters, page, per_page);
      orderStatusList.value = (data?.data ?? []).map( e => ({...e,encomenda_snapshot_json:JSON.parse(e.encomenda_snapshot_json)}));
      orderStatusTotalRecords.value = data.meta?.total_count ?? 0;
      return data;
    } catch (error) {
      console.log("getLicenseOrderStatus", error);
      orderStatusList.value = [];
      orderStatusTotalRecords.value = 0;
    }
  }



  async function getTransactionsByOrderId(orderId) {
    try {
      const data = await ls.getTransactionsByOrderId(token.value, orderId);
      transactionsList.value = data?.data ?? [];
      return {
        success: true,
        message: "transactions.success",
        data: data,
      };
    } catch (error) {
      console.log("getTransactionsByOrderId", error);
      transactionsList.value = [];
      return {
        success: false,
        message: "transactions.error",
        data: error,
      };
    }
  }

  async function getTransactionsByTraceId(traceId) {
    try {
      const data = await ls.getTransactionsByTraceId(token.value, traceId);
      transactionsList.value = data?.data ?? [];
      return {
        success: true,
        message: "transactions.success",
        data: data,
      };
    } catch (error) {
      console.log("getTransactionsByTraceId", error);
      transactionsList.value = [];
      return {
        success: false,
        message: "transactions.error",
        data: error,
      };
    }
  }

  async function getLocalLicenses(page = 1, perPage = 10, filters = {}) {
    try {   
    const normalizedFilters = {}
    for(const key of Object.keys(filters)){
        if(key == 'status'){
          // ZSLW-711: data_validade (BE) covers both limitecontrato and the legacy POS/REST datalimite
          if(filters[key]== 'ACTIVE') normalizedFilters['data_validade_gt'] = 'now()';
          if(filters[key] == 'INACTIVE') normalizedFilters['data_validade_lte'] ='now()';
        }else {
          normalizedFilters[key] = filters[key]
        }
    }

      const data = await ls.getLocalLicenses(token.value, page, perPage, normalizedFilters);
      const list = data?.data ?? [];
      localLicenses.value = list;
      localLicensesTotalRecords.value = data.meta.total_items;
      return list;
    } catch (error) {
      localLicenses.value = [];
      localLicensesTotalRecords.value = 0;
      throw error;
    }
  }

  async function getPartnerCredits(partnerId, softwareId, licenseType) {
    try {
      const data = await ls.getPartnerCredits(
        token.value,
        partnerId,
        softwareId,
        licenseType
      );
      return {
        success: true,
        message: "credits.success",
        data: data,
      };
    } catch (error) {
      return {
        success: false,
        message: "credits.error",
        data: error,
      };
    }
  }

  async function searchPartners(searchParams = {}) {
    try {
      const data = await ls.searchPartners(token.value, searchParams);
      return {
        success: true,
        message: "partners_search.success",
        data: data,
      };
    } catch (error) {
      console.error("Error searching partners:", error);
      return {
        success: false,
        message: error.response?.data?.message || "partners_search.error",
        data: error,
      };
    }
  }

  async function refundCredits(order_id,partnerId, amount, reason) {
    try {
      const data = await ls.refundCredits(token.value,order_id, partnerId, amount, reason);
      return {
        success: true,
        message: "general.credits_refund.success",
        data: data,
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || "general.credits_refund.error",
        data: error,
      };
    }
  }

  async function getExpiredLicenses(page = 1, perPage = 10, filters = {}) {
    try {
      const data = await ls.getExpiredLicenses(token.value, page, perPage, filters);
      const list = data?.data ?? [];
      expiredLicenses.value = list;
      expiredLicensesTotalRecords.value = data.meta.total_items;
      return list;
    } catch (error) {
      expiredLicenses.value = [];
      expiredLicensesTotalRecords.value = 0;
      throw error;
    }
  }

  async function getAboutToExpireLicenses(page = 1, perPage = 10, filters = {}) {
    try {
      const data = await ls.getAboutToExpireLicenses(token.value, page, perPage, filters);
      const list = data?.data ?? [];
      aboutToExpireLicenses.value = list;
      aboutToExpireLicensesTotalRecords.value = data.meta.total_items;
      return list;
    } catch (error) {
      aboutToExpireLicenses.value = [];
      aboutToExpireLicensesTotalRecords.value = 0;
      throw error;
    }
  }

  async function getPendingLicenses(page = 1, perPage = 10, filters = {}) {
    try {
      const data = await ls.getPendingLicensesWithFilters(token.value, page, perPage, filters);
      const list = data?.data ?? [];
      pendingLicenses.value = list;
      pendingLicensesTotalRecords.value = data.meta.total_items;
      return list;
    } catch (error) {
      pendingLicenses.value = [];
      pendingLicensesTotalRecords.value = 0;
      throw error;
    }
  }

  // Hardware Request Status Methods
  async function getHardwareRequestStatusList(page = 1, per_page = 10, filters = {}, sort = null) {
    try {
      const data = await ls.getHardwareRequestStatusList(token.value, page, per_page, filters, sort);
      hardwareRequestStatusList.value = data?.data ?? [];
      hardwareRequestStatusTotalRecords.value = data.meta?.total_items ?? 0;
      return data;
    } catch (error) {
      console.log("getHardwareRequestStatusList", error);
      hardwareRequestStatusList.value = [];
      hardwareRequestStatusTotalRecords.value = 0;
      throw error;
    }
  }

  // Hardware Request ID persistence
  const LAST_REQUEST_ID_KEY = 'zslic_last_hardware_request_id';

  function getLastRequestIdFromStorage() {
    try {
      const stored = localStorage.getItem(LAST_REQUEST_ID_KEY);
      return stored ? parseInt(stored, 10) : -1;
    } catch (error) {
      console.error('Error reading lastRequestId from localStorage:', error);
      return -1;
    }
  }

  function saveLastRequestIdToStorage(id) {
    try {
      localStorage.setItem(LAST_REQUEST_ID_KEY, id.toString());
    } catch (error) {
      console.error('Error saving lastRequestId to localStorage:', error);
    }
  }

  let lastRequestId = getLastRequestIdFromStorage();

  async function CheckForNewHardwareRequests(){
    const filter ={sc: 'AND', status: 1, sort_date: 'DESC'}
    const data = await ls.getHardwareRequestStatusList(token.value, 1,1,filter, null);
    const list = data?.data ?? [];
    if(list.length > 0){
      if(list[0].id > lastRequestId) {
        lastRequestId = list[0].id;
        const last = getLastRequestIdFromStorage();
        saveLastRequestIdToStorage(lastRequestId);
        return last > 0
      }
    }
    return false
  }

  async function updateHardwareRequestStatus(id, status, data = null) {
    try {
      const response = await ls.updateHardwareRequestStatus(token.value, id, status, data);
      return {
        success: true,
        message: "hardware_request.update_success",
        data: response,
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || "hardware_request.update_error",
        data: error,
      };
    }
  }

	async function getCancellationDate(serial) {
	    try {
	      const data = await ls.getCancellationDate(token.value, serial);
	      return data?.data?.cancellation_date ?? null;
	    } catch (error) {
	      return null;
	    }
	  }

	async function cancelLicense(stores, serial, cloudkeeper, userId) {
	    try {
	      const data = await ls.cancelLicense(token.value, stores, serial, cloudkeeper, userId);
	      return {
	        success: true,
	        message: "license_cancel.success",
	        data: data,
	      };
	    } catch (error) {
	      return {
	        success: false,
	        message: error.response?.data?.message || "license_cancel.error",
	        data: error,
	      };
	    }
	  }

  return {

    filterLicenses,
    getLicenses2,
    licenses,
    totalRecords,
    getCampainList,
    campainList,
    getSoftwareList,
    softwareList,
    getHardwareList,
    hardwareList,
    getCampainDetail,
    selectedCampain,
    orderLicense,
    orderLicenseV2,
    getSerialEmail,
    updateSerialEmail,
    getExpiringLicenceList,
    expiredLicenses,
    expiredLicensesTotalRecords,
    aboutToExpireLicenses,
    aboutToExpireLicensesTotalRecords,
    getExpiredLicenses,
    getAboutToExpireLicenses,
    getInactiveLicenceList,
    inactiveLicenses,
    getLicenseFile,
    renewLicense,
    checkNif,
    validateEmail,
    countryList,
    getPendingLicenceList,
    pendingLicenses,
    pendingLicensesTotalRecords,
    getPendingLicenses,
    disableLicense,
    enableLicense,
    list_page,
    companyName,
    nif,
    clientNumber,
    software,
    serialNumber,
    state,
    visible_state,
    resetFilters,
    exportLicenceList,
    exportLocalLicenceList,
    renewZSFACTLicense,
    checkPartnerDemoLicense,
    checkForExistingLicense,
    getZSGOLicenseData,
    orderZSGOLicenseChange,
    getLicenseOrderStatus,
    orderStatusList,
    orderStatusTotalRecords,
    getTransactionsByOrderId,
    getTransactionsByTraceId,
    transactionsList,
    getLocalLicenses,
    localLicenses,
    localLicensesTotalRecords,
    getPartnerCredits,
    searchPartners,
    refundCredits,
    // Hardware Request Status
    getHardwareRequestStatusList,
    updateHardwareRequestStatus,
    hardwareRequestStatusList,
    hardwareRequestStatusTotalRecords,


    CheckForNewHardwareRequests,
    getCancellationDate,
    cancelLicense
  };
});
